import { root } from './decoders';

export const decoders = {
  ...root,
};
